import { FormatosReporteModel } from '@/store/catalogos/formatosReporte';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormatosReporteService } from '@services/catalogo/formatosReporte.service';
import { ValidatorsService } from '@services/util/validators.service';

@Component({
  selector: 'app-formulario-formatos',
  templateUrl: './formulario-formatos.component.html',
  styleUrls: ['./formulario-formatos.component.scss']
})
export class FormularioFormatosComponent {

  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Formato";


  constructor(
    private util: Util,
    private formatosReporteService: FormatosReporteService,
    public dialogRef: MatDialogRef<FormularioFormatosComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Formato";
    }
    if (data.view) {
      this.title = "Vista Formato";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);

  }

  private buildForm(data: FormatosReporteModel): void {
    this.form = new FormGroup({
      idFormatoReporte: new FormControl(data?.idFormatoReporte ?? null),
      reporte: new FormControl(
        { value: data?.reporte ?? '', disabled: true },
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(50)]
        }
      ),
      formato: new FormControl(data?.formato ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.required, Validators.maxLength(13)]
      }),
      version: new FormControl(data?.version ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }


  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formato: FormatosReporteModel = this.formToModel();
    const request = this.data.insert
      ? this.formatosReporteService.create(formato)
      : this.formatosReporteService.update(formato);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): FormatosReporteModel {
    const formValues = this.form.getRawValue();

    return {
      idFormatoReporte: formValues.idFormatoReporte ?? '',
      reporte: formValues.reporte ?? '',
      formato: formValues.formato ?? '',
      version: formValues.version ?? ''
    };
  }
}
